import script from "./SingleTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleTransfer.vue?vue&type=script&setup=true&lang=js"

import "./SingleTransfer.vue?vue&type=style&index=0&id=09736a58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09736a58"]])

export default __exports__